import { products } from "../endpoints/products.endpoints";
import $axios from "../http/accessor";

const ProductsService = {
  getAllProducts: (page: number, count: number) => {
    return $axios.get(products.all_products, {
      params: {
        page,
        count,
      },
    });
  },

  getSingleProduct: (id: number) => {
    return $axios.get(products.single_product(id));
  },

  createProduct: (data: FormData) => {
    return $axios.post(products.create_product, data);
  },

  createProductVariant: (data: FormData) => {
    return $axios.post(products.create_product_variant, data);
  },

  createProductVariantImages: (data: FormData, product_id: number) => {
    return $axios.post(products.create_product_variant_image(product_id), data);
  },

  updateProduct: (id: number, data: FormData) => {
    return $axios.put(products.update_product(id), data);
  },

  updateProductVariant: (id: number, data: FormData) => {
    return $axios.put(products.update_product_variant(id), data);
  },

  updateProductVariantImage: (
    id: number,
    product_id: number,
    data: FormData,
  ) => {
    return $axios.put(
      products.update_product_variant_image(id, product_id),
      data,
    );
  },

  deleteProduct: (id: number) => {
    return $axios.delete(products.delete_product(id));
  },
  deleteProductVariant: (id: number, product_id: number) => {
    return $axios.delete(products.delete_product_variant(id, product_id));
  },

  getCategories: (page?: number, count?: number) => {
    return $axios.get(products.get_categories, {
      params: {
        page,
        count,
      },
    });
  },

  getCategoriesAttribute: (id: number, page?: number, count?: number) => {
    return $axios.get(products.get_categories_attribute, {
      params: {
        id,
        page,
        count,
      },
    });
  },

  getBrands: (page?: number, count?: number) => {
    return $axios.get(products.get_brands, {
      params: {
        page,
        count,
      },
    });
  },

  getCurrency: () => {
    return $axios.get(products.get_currency);
  },

  getAllVariants: (product_id: number, page: number, count: number) => {
    return $axios.get(products.get_all_variants(product_id), {
      params: {
        page,
        count,
      },
    });
  },

  getAllProductVariants: (page: number, count: number) => {
    return $axios.get(products.get_all_product_variants, {
      params: {
        page,
        count,
      },
    });
  },

  getVariantById: (id: number, product_id: number) => {
    return $axios.get(products.get_variant_by_id(id, product_id));
  },
};

export default ProductsService;
